import {
  FetchProductCountDocument,
  FetchProductCountQuery,
  FetchProductCountQueryVariables,
} from "@src/generated";
import { shopifyGqlClient } from "@src/providers/gqlProvider";

export async function loadProductCount(
  variables: FetchProductCountQueryVariables
) {
  const result = await shopifyGqlClient.query<
    FetchProductCountQuery,
    FetchProductCountQueryVariables
  >({
    query: FetchProductCountDocument,
    variables,
    fetchPolicy: "network-only",
  });

  return result.data.productsCount?.count;
}
